<script>
    export default {
        data() {
            return {
                selected: null
            };
        },
        methods: {
            toggle(id) {
                if (this.selected === id) {
                    this.selected = null;
                } else {
                    this.selected = id;
                }
            },
            isSelected(id) {
                return this.selected === id;
            },
            selectedClass(id) {
                return {
                    active: this.isSelected(id)
                }
            }
        },
        render() {
            return this.$scopedSlots.default({
                toggle: this.toggle,
                selectedClass: this.selectedClass,
                isSelected: this.isSelected
            });
        }
    };
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Reveal/Accordion.vue